<template>
    <div class="solution">
      <div class="main">
        <div class="bg1">
          <div class="model1">
            <p class="position">您所在的位置：首页 > 智慧园区</p>
            <p class="title">把数字世界带入每个园区</p>
            <p class="title2"></p>
            <div class="model1-main">
              <div class="left">
                <div class="p">平台+生态，重新定义园区</div>
                <div class="p1">江苏野马软件公司运用5G、AI、物联网、云计算、大数据等新ICT技术，基于“平台+生态”战略， 依托野马数字平台将淮海人力资源服务产业园区打造成集线上、线下服务于一体的创新型智慧园区，建立“云”服务平台，为企业和人才发展搭建关联共享产业链，提供系列化一站式智慧服务，提升管理服务效率，提高产业附加值。</div>
              </div>
              <div class="right">
                <img :src="url + '/assets/park/park-platform.png'">
              </div>
            </div>
            <div class="list">
              <div class="listArr" v-for="(item, index) in list" :key="index">
               <img :src="item.img">
                <p class="text">{{item.title}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="bg2">
          <div class="model4">
            <div class="img">
              <img :src="url + '/assets/park/1-1.png'">
              <div class="div1">
                <p class="text1">
                  跨部门协同
                </p>
                <p class="text2">
                  跨部门工作流程梳理，按不同的权限，各部门都可进行查看，打通信息部门壁垒。
                </p>
              </div>
              <div class="div2">
                <p class="text1">
                  信息传递
                </p>
                <p class="text2">对接阿里云短信平台，支持批量发送短信，支持访客提醒、人脸识别、各种审核温馨提示等。信息沟通、传达有保障。</p>
              </div>
              <div class="div3">
                <p class="text1">
                  构建大数据
                </p>
                <p class="text2">准确获取园区各项数据，包括会议室信息、人才信息、测评能力信息、需求资讯信息、设备设施信息等，全方位掌握园区运营情况。
                </p>
              </div>
              <div class="div4">
                <p class="text1">
                  园区支付平台
                </p>
                <p class="text2">
                  打造园区专属支付平台，实现了园区便捷安全的支付管理（支付宝、微信、银联等）
                </p>
              </div>
               <div class="div5">
                <p class="text1">
                  数据呈现，构建数据分析平台
                </p>
                <p class="text2">
                  PC操作，微信端查看，支持快速、有效、准确呈现各模块数据，方便查询、查看、提高工作效率、给领导快速决策提供有力保障。
                </p>
              </div>
               <div class="div6">
                <p class="text1">
                  部门业务梳理
                </p>
                <p class="text2">
                  招商、物业、安保等各部门业务梳理及规范化管理。
                </p>
              </div>
               <div class="div7">
                <p class="text1">
                  提高园区运营管理水平
                </p>
                <p class="text2">
                  通过园区运营管理平台结合产业服务平台运作，结合适合的运营方案，构建园区的企业、员工、商家的生态圈。提高园区整体管理水平。
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="bg1">
          <div class="model2 pdn">
            <p class="title">智能化平台—特色解析</p>
            <div class="title2"></div>
            <div class="list">
              <div class="list-analysis" v-for="(item, index) in list2" :key="index">
                <img :src="item.img">
                <p class="text1">{{item.name}}</p>
                <p class="text2">{{item.title}}</p>
              </div>
            </div>
          </div>
         </div>
         <div class="bg2">
          <div class="model2">
            <p class="title">不同对象至简体验</p>
            <div class="title2"></div>
            <div class="park-experience">
              <div class="park-experience-list bg1" :style="{background: 'url('+url+'/assets/park/park-experience.png) no-repeat'}">
                <p class="park-p1">个人&企业</p>
                <p class="park-p2">可以通过移动端和PC端对接丰富的社区服务资源，获取海量的本地信息资讯，自主发布客户需求，园区服务无缝对接</p>
              </div>
               <div class="park-experience-list bg2" :style="{background: 'url('+url+'/assets/park/park-experience2.png) no-repeat'}">
                <p class="park-p1">园区入驻机构</p>
                <p class="park-p2">可以借助移动端和PC端实现智慧的办公、线上线下一体化的园区综合服务，按需使用，例如：入驻服务、资讯服务、员工管理、智能访客服务、需求对接服务等，提供经营发展所需的各类服务配套支持。</p>
              </div>
               <div class="park-experience-list bg3" :style="{background: 'url('+url+'/assets/park/park-experience3.png) no-repeat'}">
                <p class="park-p1">园区运营方</p>
                <p class="park-p2">园区设备设施：可视、可管、可控。为园区各业务构建信息化应用系统，实现全面高效的园区运营管理，大数据图表绘制与分析、访客内容实时记录与更新，各种审核报表自动生成，提供了一键式服务体系</p>
              </div>
            </div>
          </div>
         </div>
         <div class="bg1">
          <div class="model3">
            <p class="title">便捷通行：“0”等待</p>
            <div class="title2"></div>
            <div class="park-convenient">
              <img class="scale" :src="url + '/assets/park/park-convenient1.png'">
              <img class="scale" :src="url + '/assets/park/park-convenient2.png'">
              <img class="scale" :src="url + '/assets/park/park-convenient3.png'">
            </div>
          </div>
         </div>
         <div class="bg2">
          <div class="model3">
            <p class="title">智能会议室预约管理</p>
            <div class="title2"></div>
            <div class="park-room">
              <img class="park-room-left scale" :src="url + '/assets/park/1-2.png'">
              <img class="park-room-right scale" :src="url + '/assets/park/park-room2.png'">
            </div>
          </div>
         </div>
        <div class="bg1">
          <div class="model3">
            <p class="title">人力资源服务业务对接可视化平台</p>
            <div class="title2"></div>
            <div class="park-visualization">
              <div class="visualization-left">
                <p class="visualization-text">在智慧园区平台数据集成整合及统计汇总的基础上，对园区企业信息、需求动态信息、人才岗位信息等，以实时动态图表、多维报表等数据图表展现方式，实现园区综合数据的统一动态展示，辅助领导分析决策。</p>
                <div class="visualization-list">
                  <div class="visualization-list-ct visualization1" :style="{background: 'url('+url+'/assets/park/park-visualization1.png) no-repeat'}">
                    企业需求情况
                  </div>
                  <div class="visualization-list-ct visualization2" :style="{background: 'url('+url+'/assets/park/park-visualization2.png) no-repeat'}">
                    园区运营分析
                  </div>
                  <div class="visualization-list-ct visualization3" :style="{background: 'url('+url+'/assets/park/park-visualization3.png) no-repeat'}">
                    园区机构动态
                  </div>
                  <div class="visualization-list-ct visualization4" :style="{background: 'url('+url+'/assets/park/park-visualization4.png) no-repeat'}">
                    人才信息统计
                  </div>
                </div>
              </div>
              <div class="visualization-right">
                 <img class="scale" :src="url + '/assets/park/park-visualization5.png'">
              </div>
            </div>
          </div>
         </div>
        <div class="bg2">
          <div class="model3">
            <p class="title">人力资源大数据分析平台 </p>
            <div class="title2"></div>
            <div class="park-visualization">
              <div class="visualization-left">
                <p class="visualization-text1">运营数据分析</p>
                <p class="visualization-text mb30">利用云计算、大数据算法等先进技术对数据进行采集、处理。对企业数据的探索式分析，实时绘制出各种动态数据，将业务数据经过处理后以实时的炫酷的可视化形式展示出来，全方位展示企业的各种动态。</p>
                 <p class="visualization-text1">价值点</p>
                <div class="visualization-list">
                  <div class="park-data1" :style="{background: 'url('+url+'/assets/park/park-data1.png) no-repeat'}">
                    运营状况一目了然
                  </div>
                  <div class="park-data1" :style="{background: 'url('+url+'/assets/park/park-data1.png) no-repeat'}">
                    多维数据有效挖掘
                  </div>
                </div>
              </div>
              <div class="visualization-right">
                 <img class="scale" :src="url + '/assets/park/park-data.png'">
              </div>
            </div>
          </div>
         </div>
      </div>
      <foot></foot>
    </div>
</template>
<script>
import defaultSettings from '@/defaultSettings'
import foot from '../components/foot'
const img1 = defaultSettings.url + '/assets/park/park-icon1.png'
const img2 =  defaultSettings.url + '/assets/park/park-icon2.png'
const img3 =  defaultSettings.url + '/assets/park/park-icon3.png'
const img4 =  defaultSettings.url + '/assets/park/park-icon4.png'
const characteristic1 =  defaultSettings.url + '/assets/park/park-characteristic1.png'
const characteristic2 =  defaultSettings.url + '/assets/park/park-characteristic2.png'
const characteristic3 =  defaultSettings.url + '/assets/park/park-characteristic3.png'
const characteristic4 =  defaultSettings.url + '/assets/park/park-characteristic4.png'
const characteristic5 =  defaultSettings.url + '/assets/park/park-characteristic5.png'
const characteristic6 =  defaultSettings.url + '/assets/park/park-characteristic6.png'
export default {
  data() {
    return {
      url: defaultSettings.url,
      list:[
        {
          img: img1,
          title: '助力客户数字化转型，助力客户园区实现整体智慧化，以科技为园区赋能'
        },
        {
          img: img2,
          title: '实现园区：状态可观、事件可控、业务可管，数据统一分类、实现、分析GIS一张图管理'
        },
        {
          img: img3,
          title: '跨部门、跨区域、跨系统的协作，掌握全局态势，统一资源调度，掌控运营态势'
        },
        {
          img: img4,
          title: '无处不在的联接、无所不及的智能、为园区业务创新带来无限可能'
        }
      ],
      list2:[
        {
          img: characteristic1,
          name: '智能访客',
          title: '企业等角色拜访单和入驻机构邀请单的交互操作，实现线上预约洽谈、陌生拜访等线上常用业务的在线化'
        },
        {
          img: characteristic2,
          name: '消息通知',
          title: '实时操作消息通知，客户可以及时了解各种动态，便于第一时间处理业务信息'
        },
        {
          img: characteristic3,
          name: '人脸识别',
          title: '响应访客系统，动态人脸识别，轻松应对不同光线强弱的室内外场景和人脸化妆遮挡，稳定性强，简洁系统操作界面，功能强大，能对人脸信息进行统计'
        },
        {
          img: characteristic4,
          name: '统计分析',
          title: '大数据精简处理，汇总精华数据，实时反映客观实际，便于阅读、理解和利用。为决策者提供信息咨询和监督服务'
        },
        {
          img: characteristic5,
          name: '需求对接',
          title: '付费抢单模式，企业等角色需求方和入驻机构的交互功能操作，实现线上洽谈、需求对接'
        },
        {
          img: characteristic6,
          name: '智能会议室',
          title: '会议室集中在线管理，占用状态透明可视，线上即可轻松预定，人脸识别签到，会议室自动开启，实现会前一键预约，会中设备智能控制，会后自动释放资源'
        }
      ]
    }
  },
  components: {
    foot
  },
    mounted() {
    window.scrollTo({ left: 0, top: 0 })
  },
  methods: {
  }
}
</script>
<style lang="less" scoped>
.bg1{
  background: #F9F9F9;
}
.bg2{
  background: #fff;
}
.title{
  color:#333;
  font-size:34px;
  text-align: left;
}
.title2:after {
  display: block;
  content: "";
  height: 0;
  line-height: 0;
  visibility: hidden;
  clear: both;
}
.title2 {
  zoom: 1; /* 为了兼容IE */
}
.title2{
  width: 87px;
  height: 3px;
  background: #167EFB;
  text-align: left;
  margin:30px 0 25px;
  display: block;
}
// 缩放
.scale{
    width:100%;
    transition: all 0.6s;
}
.scale:hover{
    transition: all 0.6s;
    transform: scale(1.08);
}

.solution{
  padding-top:140px;
  background: #F9F9F9;
  .main{
    .model1{
        margin-top:84px;
        width:1200px;
        margin: 0 auto;
        padding-bottom:70px;
        .position{
          margin-top:25px;
          color:#999999;
          font-size:14px;
          margin-bottom:50px;
        }
        .title{
          color:#333;
          font-size:34px;
          text-align: center;
        }
        .title2{
          width: 87px;
          height: 3px;
          background: #167EFB;
          text-align: center;
          margin:30px auto 60px;
        }
        .title-text{
          width:960px;
          text-align: center;
          margin:0 auto;
          color:#333;
          font-size:14px;
          line-height: 30px;
        }
        .model1-main{
          padding-bottom:85px;
          display: flex;
          .left{
            width:545px;
            .p{
              font-size:24px;
              color:#333;
              margin-bottom:50px;
              line-height: 30px;
            }
            .p1{
              margin-bottom:15px;
              line-height: 30px;
              color:#666;
              font-size:16px;
            }
          }
          .right{
              margin-left:70px;
              width:815px;
              height:257px;
            img{
              width:815px;
              height:257px;
            }
          }
        }
        .list{
          .listArr{
            text-align: center;
            width:24.5%;
            vertical-align: top;
            display: inline-block;
            img{
              width:97px;
              height:97px;
              margin-bottom:20px;
            }
            .text{
              font-size:14px;
              color:#666;
              width:220px;
              text-align: center;
              margin:0 auto;
              line-height: 30px;
            }
        }
      }
    }
    .model2{
      width:1200px;
      margin: 0px auto;
      padding-top:80px;
      padding-bottom:70px;
      .list{
        .list-analysis{
          display: inline-block;
          padding:30px 40px;
          min-height:300px;
         transition: all 0.6s;
          width:23.5%;
          margin-right:50px;
          margin-bottom:50px;
          text-align: center;
          vertical-align: top;
          img{
            margin-bottom:28px;
            width:138px;
            height:98px;
          }
          .text1{
            font-size:18px;
            margin-bottom:20px;
            color:#333;
          }
          .text2{
            font-size:14px;
            line-height: 30px;
            color:#666;
          }
        }
        .list-analysis:nth-child(3n){
           margin-right:0px;
        }
        .list-analysis:hover{
          background: #fff;
           transition: all 0.6s;
          transform: translate(0,-8px);
        }
      }
      .park-experience{
        .park-experience-list{
          display: inline-block;
          padding:40px 50px 0 30px;
          width:300px;
          height:330px;
          transition: all 0.6s;
          margin-right:20px;
          text-align: left;
          vertical-align: top;
          .park-p1{
            font-size:24px;
            color:#333;
            margin-bottom:30px;
          }
          .park-p2{
            font-size:14px;
            color:#666;
            line-height:30px;
          }
        }
        .bg1{
          background-size: 100% 100%!important;
        }
        .bg2{
          background-size: 100% 100%!important;
        }
        .bg3{
          background-size: 100% 100%!important;
        }
        .park-experience-list:nth-child(3n){
          margin-right:0px;
        }
        .park-experience-list:hover{
          transition: all 0.6s;
          transform: scale(1.08);
        }
      }
    }
    .pdn{
      padding-bottom:0;
    }
    .model4{
      width:1200px;
      margin: 0px auto;
      text-align: center;
      padding-top:76px;
      .img{
        position: relative;
        margin: 0px auto;
        width:704px;
        height:560px;
        img{
          width:704px;
          height:560px;
        }
        .text1{
          font-size:18px;
          color:#333;
          margin-bottom:20px;
        }
        .text2{
          font-size:14px;
          color:#666;
          line-height:20px;
        }
        .div1{
          position: absolute;
          left:-230px;
          bottom:50px;
          text-align: right;
          width:220px;
        }
        .div2{
          position: absolute;
          left:-200px;
          bottom:208px;
          text-align: right;
          width:220px;
        }
        .div3{
          position: absolute;
          left:-90px;
          bottom:358px;
          text-align: right;
          width:220px;
        }
        .div4{
          position: absolute;
          left:290px;
          bottom:456px;
          text-align: LEFT;
          width:220px;
        }
        .div5{
          position: absolute;
          left:580px;
          bottom:348px;
          text-align: LEFT;
          width:220px;
        }
        .div6{
          position: absolute;
          left:670px;
          bottom:258px;
          text-align: LEFT;
          width:220px;
        }
        .div7{
          position: absolute;
          left:720px;
          bottom:38px;
          text-align: LEFT;
          width:220px;
        }
      }
    }
    .model3{
      width:1200px;
      margin: 0px auto;
      padding-top:60px;
      .park-convenient{
        img{
          height:516px;
          margin-bottom:40px;
        }
      }
      .park-room{
        display: flex;
         vertical-align: middle;
        .park-room-left{
          width:564px;
          height:396px;
          margin-top:50px;
        }
        .park-room-right{
          width:678px;
          height:524px;
        }
      }
      .park-visualization{
        margin:60px 0 0px 0;
        display: flex;
        .visualization-left{
          width:346px;
          .visualization-text1{
            margin-bottom:20px;
            color:#333;
            font-size:20px;
          }
          .visualization-text{
            margin-bottom:50px;
            color:#666;
            font-size:14px;
            line-height: 30px;
          }
          .mb30{
            margin-bottom:25px;
          }
          .visualization-list{
             padding-bottom:60px;
            .visualization-list-ct{
              width:120px;
              height:40px;
              line-height: 40px;
              padding-left:45px;
              color:#FF9F01;
              font-size:16px;
              margin-right:10px;
              margin-bottom:15px;
              display: inline-block;
            }
            .visualization-list-ct:nth-child(2n){
               margin-right:0px;
            }
            .visualization1{
              background-size: 100% 100%!important;
            }
            .visualization2{
              background-size: 100% 100%!important;
            }
            .visualization3{
              background-size: 100% 100%!important;
            }
            .visualization4{
              background-size: 100% 100%!important;
            }
            .park-data1{
              background-size: 100% 100%!important;
               width:160px;
              height:40px;
              line-height: 40px;
              text-align: center;
              color:#FF9F01;
              font-size:16px;
              margin-right:10px;
              margin-bottom:15px;
              display: inline-block;
            }
          }
        }
        .visualization-right{
          width:815px;
          height:281px;
          margin-left:30px;
          img{
            width:815px;
            height:281px;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/park.vue